import React from "react";
import HUDFrame from "./HUDFrame";

/**
 * Feature-page scanner: shows a product photo inside an animated
 * HUD radar frame with corner brackets and tick marks.
 */
export default function BudScanner({
  image = "https://images.unsplash.com/photo-1603909223429-69bb7101f420?auto=format&fit=crop&w=1600&q=85",
  label = "SCAN COMPLETE",
  score = "98.7%",
  alt = "Product scan",
}) {
  return (
    <div className="relative w-full max-w-[560px] mx-auto">
      <div className="scanner-frame">
        <div className="scanner-ring" />
        <div className="scanner-ring solid" />

        {/* Scan image */}
        <div className="absolute inset-[14%] rounded-full overflow-hidden" style={{ clipPath: "circle(50%)" }}>
          <img
            src={image}
            alt={alt}
            className="w-full h-full object-cover"
            style={{
              filter: "saturate(1.05) contrast(1.05) drop-shadow(0 0 20px rgba(157,252,4,0.25))",
            }}
          />
          <div
            className="absolute inset-0"
            style={{
              background:
                "radial-gradient(circle at 50% 40%, transparent 40%, rgba(0,0,0,0.45) 80%, rgba(0,0,0,0.85) 100%)",
            }}
          />
        </div>

        <div className="scanner-corners">
          <span />
          <span />
          <span />
          <span />
        </div>

        {/* Perimeter ticks */}
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 200 200" aria-hidden="true">
          {Array.from({ length: 80 }).map((_, i) => {
            const a = (i / 80) * Math.PI * 2;
            const r1 = 92;
            const r2 = i % 5 === 0 ? 80 : 86;
            return (
              <line
                key={i}
                x1={100 + Math.cos(a) * r1}
                y1={100 + Math.sin(a) * r1}
                x2={100 + Math.cos(a) * r2}
                y2={100 + Math.sin(a) * r2}
                stroke="rgba(157,252,4,0.55)"
                strokeWidth="1"
              />
            );
          })}
        </svg>

        {/* Scanning line */}
        <div
          className="absolute left-[14%] right-[14%] h-[2px] bg-[color:var(--ss-green)]"
          style={{
            top: "50%",
            boxShadow: "0 0 18px var(--ss-green)",
            animation: "bud-scan 3.6s ease-in-out infinite alternate",
          }}
        />
      </div>

      <HUDFrame padding="px-5 py-3" className="absolute -bottom-6 left-1/2 -translate-x-1/2 w-[min(94%,440px)]">
        <div className="flex items-center justify-between">
          <div className="text-[11px] font-display tracking-[0.3em] text-[color:var(--ss-green)]">
            {label}
          </div>
          <div className="font-mono text-[color:var(--ss-green)] font-bold">
            CONFIDENCE: {score}
          </div>
        </div>
        <div className="bar-mini mt-2">
          {Array.from({ length: 36 }).map((_, i) => (
            <span key={i} style={{ height: `${8 + Math.random() * 14}px` }} />
          ))}
        </div>
      </HUDFrame>
    </div>
  );
}
